export default __webpack_public_path__ + "static/Fall3-e33cbf1b442caa114e284af0102ea1ee.mp3";